
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 28 32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"#8990A3FF","d":"M24 14h-2V8c0-4.41213-3.5879-8-8-8-4.41212 0-8 3.58787-8 8v6H4c-2.20913 0-4 1.7908-4 4v10c0 2.2091 1.79087 4 4 4h20c2.2092 0 4-1.7909 4-4V18c0-2.2092-1.7908-4-4-4zM8 8c0-3.30863 2.6914-6 6-6s6 2.69137 6 6v6H8V8zm18 20c0 1.1028-.8972 2-2 2H4c-1.10281 0-2-.8972-2-2V18c0-1.1028.89719-2 2-2h20c1.1028 0 2 .8972 2 2v10zm-12-8c-.5527 0-1 .4473-1 1v4c0 .5527.4473 1 1 1s1-.4473 1-1v-4c0-.5527-.4473-1-1-1z"}})])
          )
        }
      }
    